import styled, { css } from 'styled-components';
import { smLayout, xlLayout, mdLayout, uxLayout, dot } from './homeStyles';

export const OnAirBody = styled.header`
  padding: 0 15%;
  display: flex;
  flex-direction: column;

  & .pipOpenArea {
    width: 100%;
    height: 600px;
    background-color: #aaaaaa;

    ${mdLayout} {
      min-height: 450px;
    }
  }

  & .vodDetail-info {
    padding: 30px 24px;
    justify-content: space-between;
    border-bottom: 1px solid ${props => props.theme.line};

    & span {
      color: ${props => props.theme.button};
      font-size: 18px;
      font-weight: 800;
      margin-right: 20px;
    }
    & div {
      flex: 2;
      & h1 {
        color: ${props => props.theme.text};
        font-size: 24px;
        font-weight: 800;
        margin: 0;
        margin-bottom: 5px;
      }
      & h3 {
        color: ${props => props.theme.subText};
        font-size: 17px;
      }
      & > div {
        color: ${props => props.theme.subText};
        font-size: 15px;
      }
    }
    & button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 7px 12px;
      border: 1px solid ${props => props.theme.line};
      background-color: transparent;
      & svg {
        color: ${props => props.theme.subText};
        font-size: 18px;
      }
    }
  }

  ${uxLayout} {
    padding: 3em 20% 0;
  }

  ${xlLayout} {
    padding: 5% 11%;
  }

  ${smLayout} {
    padding: 0 0 1em;

    & .vodDetail-info {
      padding: 17px 14px;
      border-bottom: none;

      & span {
        font-size: 15px;
      }
      & div {
        flex: 2;
        & h1 {
          font-size: 16px;
          margin-bottom: 2px;
        }
        & h3 {
          font-size: 13px;
        }
        & > div {
          font-size: 13px;
        }
      }
    }
  }
`;

export const OnAirVideoContainer = styled.div`
  width: 100%;
  height: auto;
  background: #555555;

  & #ftvVideoPip {
    height: 100%;
  }

  ${props =>
    props.PipOpen &&
    css`
      & #ftvVideoPip {
        position: fixed !important;
        width: 450px !important;
        height: 254px !important;
        min-height: auto !important;
        z-index: 100000 !important;
        bottom: 50px;
        right: 0;

        & #videoContainer {
          height: 100% !important;
          min-height:  100% !important;
        }

        & .__playShare {
          display: none;
        }

        & .pipClose {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          & span {
            width: 34px;
            height: 34px;
            margin: 0 10px 10px 0;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            0px 0px 2px 2px #555555;
            color: ${props => props.theme.background};
            background-color: ${props => props.theme.subText};
          }
        }
      }
    `}

  ${smLayout} {
    height: 100%;
  }
`;

export const OnAirTable = styled.article`
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  color: ${props => props.theme.cancelText};
  position: relative;

  ${smLayout} {
    padding: 24px 5%;
    background-color: ${props => props.theme.secondaryBackground};
  }
`;

export const OnAirContetns = styled.div`
  width: 100%;
  min-height: 180px;
  padding: 0;
  position: relative;
  & h2 {
    display: none;
    font-weight: bold;
  }
  & h1 {
    font-size: 15px;
    font-weight: bold;
    margin: 0;
  }
  & h3 {
    font-size: 15px;
    font-weight: 900;
  }
  & p {
    width: 80%;
    font-size: 13px;
    margin-top: 5px;
  }

  & div {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: ${props => props.theme.secondaryBackground};
    background-color: ${props => props.theme.cancelText};
    margin-top: 50px;
  }
  & span {
    display: block;
    width: 100%;
    height: 6px;
    content: '';
    margin: 10px 0;
  }

  &:before {
    display: block;
    width: 100%;
    height: 4px;
    content: '';
    border: 1px solid ${props => props.theme.airLine};
    background-color: ${props => props.theme.airLine};
    margin: 10px 0;
    position: absolute;
    top: 10.5%;
  }

  ${props =>
    props.active &&
    css`
      & h2 {
        position: relative;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        color: ${props => props.theme.button};

        &:after {
          content: '';
          position: absolute;
          top: 0%;
          right: -10%;
          width: 4px;
          height: 4px;
          background-color: #f33;
          border-radius: 100%;
          animation: ${dot} 1s infinite alternate ease;
        }
      }

      & h1 {
        color: ${props => props.theme.text};
        font-weight: bold;
        font-size: 17px;
      }

      & h3 {
        color: ${props => props.theme.button};
        font-weight: bold;
        font-size: 15px;
      }

      & p {
        color: ${props => props.theme.text};
      }

      & div {
        background-color: ${props => props.theme.button};
        color: #fff;
      }

      &:after {
        display: block;
        width: ${props => props.gauge}%;
        height: 4px;
        content: '';
        margin: 10px 0;
        border: 1px solid ${props => props.theme.button};
        background-color: ${props => props.theme.button};
        z-index: 3;
        position: absolute;
        top: 10.5%;
        transition: width 0.5s;
      }
    `}

  ${smLayout} {
    width: 100%;
    min-height: 100%;
    padding: 0;

    & span {
      margin: 10px 0;
    }
    & p {
      display: none;
    }
    & > div {
      margin-top: 0;
      position: absolute;
      top: 0%;
      right: 10px;
    }
    &:before {
      top: 44%;
    }
    &:after {
      top: 44%;
    }
  }
`;

export const OnAirShowComponent = styled.nav`
  display: flex;
  padding: 12px 0;
  align-items: center;

  & span {
    color: ${props => props.theme.subText};
    background-color: transparent;
    font-weight: bold;
    padding: 0 15px;
  }

  & h1 {
    flex: 2;
    color: ${props => props.theme.subText};
    font-size: 16px;
    font-weight: bold;
  }

  & p {
    color: ${props => props.theme.subText};
    font-size: 14px;
    font-weight: bold;
  }

  ${props =>
    props.position &&
    css`
      border-${props.position}: 1px solid ${props => props.theme.line};
    `}

  ${smLayout} {
    padding: 16px;
  }
`;

export const OnAirScheduleBtn = styled.button`
  color: ${props => props.theme.subText};
  border: 1px solid ${props => props.theme.line};
  font-size: 14px;
  padding: 7px;

  ${smLayout} {
    margin: 17px 0;
    width: 100%;

    color: ${props => props.theme.text};
    background-color: ${props => props.theme.line};
    padding: 13px 7px;
  }
`;
